
export const plural = (noun, count) => {
    if (count === 1) {
        return noun;
    }
    return esList["includes"](noun) ? noun + "es" : noun + "s";
};

const esList = ["address"];